<template>
  <div>
    <PageAllow controller="Configs" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="8" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherKeyword
                ref="name"
                v-model="options.name"
                @text="keyword = $event"
                :label="$t('Units.title')"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="4" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-spacer />
              <v-btn
                v-if="$permission.permissionAllow('Configs', 'add')"
                small
                color="primary"
                @click.stop="addDialog = true"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("Units.add") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="units"
            :options.sync="options"
            :loading="loading"
            multi-sort
            class="elevation-2 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>

            <!-- 编辑 -->
            <template v-slot:item.weight_flg="props">
              <ValidationObserver ref="observer">
                <v-edit-dialog
                  :return-value.sync="props.item.weight_flg"
                  large
                  :cancel-text="$t('CRUD.abandon')"
                  :save-text="$t('CRUD.confirm')"
                  @save="save(currentItem)"
                  @open="currentItem = JSON.parse(JSON.stringify(props.item))"
                >
                  <v-chip
                    small
                    label
                    :color="props.item.weight_flg | weightFlgsColor"
                    :text-color="props.item.weight_flg | weightFlgsTextColor"
                  >
                    {{ props.item.weight_flg | weightFlgsText }}
                  </v-chip>
                  <span v-if="props.item.weight_rate" class="ml-2">
                    {{ "1" + props.item.name + "=" + props.item.weight_rate }}g
                  </span>
                  <template v-slot:input>
                    <div>
                      <div class="mt-4 title">
                        {{ $t("Units.Fields.weight_flg") }}
                      </div>
                      <v-row align="center">
                        <v-col cols="9" md="7">
                          <v-radio-group row v-model="currentItem.weight_flg">
                            <v-radio
                              :label="$t('Units.weightFlg.on')"
                              :key="1"
                              :value="1"
                            />
                            <v-radio
                              :label="$t('Units.weightFlg.off')"
                              :key="0"
                              :value="0"
                            />
                          </v-radio-group>
                        </v-col>
                      </v-row>
                      <v-row v-if="currentItem.weight_flg == 1">
                        <v-col cols="9" md="7">
                          <v-row class="pl-3">
                            <span class="pt-1 mr-2">
                              {{ "1" + currentItem.name }} =
                            </span>
                            <v-text-field
                              dense
                              type="number"
                              suffix="g"
                              style="max-width: 70px"
                              v-model="currentItem.weight_rate"
                            >
                            </v-text-field>
                          </v-row>
                        </v-col>
                      </v-row>
                    </div>
                  </template>
                </v-edit-dialog>
              </ValidationObserver>
            </template>
            <template v-slot:item.net_flg="props">
              <ValidationObserver ref="observer">
                <v-edit-dialog
                  :return-value.sync="props.item.net_flg"
                  large
                  :cancel-text="$t('CRUD.abandon')"
                  :save-text="$t('CRUD.confirm')"
                  @save="save(currentItem)"
                  @open="currentItem = JSON.parse(JSON.stringify(props.item))"
                >
                  <v-chip
                    small
                    label
                    :color="props.item.net_flg | netFlgsColor"
                    :text-color="props.item.net_flg | netFlgsTextColor"
                  >
                    {{ props.item.net_flg | netFlgsText }}
                  </v-chip>
                  <template v-slot:input>
                    <div>
                      <div class="mt-4 title">
                        {{ $t("Units.Fields.net_flg") }}
                      </div>
                      <v-row align="center">
                        <v-col cols="9" md="7">
                          <v-radio-group row v-model="currentItem.net_flg">
                            <v-radio
                              :label="$t('Units.netFlg.on')"
                              :key="1"
                              :value="1"
                            />
                            <v-radio
                              :label="$t('Units.netFlg.off')"
                              :key="0"
                              :value="0"
                            />
                          </v-radio-group>
                        </v-col>
                      </v-row>
                    </div>
                  </template>
                </v-edit-dialog>
              </ValidationObserver>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>

    <v-dialog persistent v-model="addDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{ $t("Units.title") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="addDialog = false"
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("Units.title")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="observer">
              <v-form>
                <v-row>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Units.Fields.unit')"
                      rules="required"
                    >
                      <v-text-field
                        required
                        v-model="newItem.name"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'name')
                            .concat(errors)
                        "
                      >
                        <template v-slot:label>
                          {{ $t("Units.Fields.unit") }}
                          <span class="red--text">*</span>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="4" class="text-left">
                    {{ $t("Units.Fields.weight_flg") + $t("Global.colon") }}
                    <span class="red--text">*</span>
                  </v-col>
                  <v-col cols="8" md="7">
                    <v-radio-group row v-model="newItem.weight_flg">
                      <v-radio
                        :label="$t('Units.weightFlg.on')"
                        :key="1"
                        :value="1"
                      />
                      <v-radio
                        :label="$t('Units.weightFlg.off')"
                        :key="0"
                        :value="0"
                      />
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="4" class="text-left">
                    {{ $t("Units.Fields.net_flg") + $t("Global.colon") }}
                    <span class="red--text">*</span>
                  </v-col>
                  <v-col cols="8" md="7">
                    <v-radio-group row v-model="newItem.net_flg">
                      <v-radio
                        :label="$t('Units.netFlg.on')"
                        :key="1"
                        :value="1"
                      />
                      <v-radio
                        :label="$t('Units.netFlg.off')"
                        :key="0"
                        :value="0"
                      />
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row v-if="newItem.weight_flg == 1 && newItem.name">
                  <v-col cols="9" md="7">
                    <v-row class="pl-3">
                      <span class="pt-1 mr-2">
                        {{ "1" + newItem.name }} =
                      </span>
                      <v-text-field
                        dense
                        type="number"
                        suffix="g"
                        style="max-width: 70px"
                        v-model="newItem.weight_rate"
                      >
                      </v-text-field>
                    </v-row>
                  </v-col>
                </v-row>
              </v-form>
            </ValidationObserver>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="addDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="accent" @click="save()">
            {{ $t("CRUD.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
// import Required from "@/components/plugins/Required";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import MaterialUnits from "@/api/material_units";

const defaultOptions = {
  name: "",
  // net_flg: null,
  // weight_flg: null,
};
export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
    ValidationObserver,
    ValidationProvider,
    // Required,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.materialManagement"),
        disabled: false,
        replace: true,
        href: "/materials",
      },
      {
        text: i18n.t("Nav.units"),
        disabled: true,
        href: "/unit",
      },
    ],
    headers: () => [
      // {
      //   text: i18n.t("Units.Fields.number"),
      //   align: "start",
      //   sortable: false,
      //   value: "id",
      // },
      {
        text: i18n.t("Units.Fields.unit"),
        align: "center",
        sortable: false,
        value: "name",
      },
      {
        text: i18n.t("Units.Fields.weight_flg"),
        align: "start",
        sortable: false,
        value: "weight_flg",
      },
      {
        text: i18n.t("Units.Fields.net_flg"),
        align: "start",
        sortable: false,
        value: "net_flg",
      },
    ],
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  mounted() {
    this.getUnitsFromAPI();
  },

  data: () => ({
    keyword: "",
    paging: {},
    units: [],
    options: JSON.parse(JSON.stringify(defaultOptions)),
    addDialog: false,
    newItem: {
      net_flg: 0,
      weight_flg: 0,
    },
    serverErrors: [],
    currentItem: {},
  }),

  methods: {
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        name: this.keyword,
      });
    },
    getUnitsFromAPI() {
      MaterialUnits.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.units = response.data.units;

            this.paging = response.data.paging;
          }
        }.bind(this)
      );
    },
    save(unit) {
      // console.log(unit);
      if (unit) {
        MaterialUnits.save(unit.id, unit).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getUnitsFromAPI();
            }
          }.bind(this)
        );
      } else {
        this.serverErrors = []; //重置远端错误提示
        this.$refs.observer.validate().then(
          async function (result) {
            if (result) {
              MaterialUnits.save("", this.newItem).then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.addDialog = false;
                    this.getUnitsFromAPI();
                  } else if (
                    response.data.error &&
                    response.data.error.data &&
                    "ERR333" == response.data.error.code
                  ) {
                    this.serverErrors = response.data.error.data;
                  }
                }.bind(this)
              );
            }
          }.bind(this)
        );
      }
    },
  },

  watch: {
    options: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getUnitsFromAPI();
      },
    },
    addDialog: {
      handler() {
        if (!this.addDialog) {
          this.serverErrors = []; //重置远端错误提示
          this.$refs.observer.reset();
          this.newItem = {
            net_flg: 0,
            weight_flg: 0,
          };
        }
      },
    },
    units: {
      deep: true,
      handler() {
        this.units.forEach((detail) => {
          if (detail.weight_flg == 0) {
            detail.weight_rate = null;
          }
        });
      },
    },
    newItem: {
      deep: true,
      handler() {
        if (this.newItem.weight_flg == 0 || !this.newItem.name) {
          this.newItem.weight_rate = null;
        }
      },
    },
  },

  beforeDestroy() {
    this.$store.dispatch("threadLoadingStopAll");
  },
};
</script>